import React, { Fragment } from 'react';

export default class Newsletter extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      address: '',
      email: '',
      acceptedTOS: false,
      loading: true
    };
  }

  componentDidMount () {
    this.setState({
      address: Storage.getState().account.currentAccount,
      loading: false
    });
  }

  renderComponentClasses () {
    if (!this.state.loading) {
      return 'c-component c-newsletter';
    }

    return 'c-component c-newsletter c-component--loading';
  }

  renderForm () {
    return (
      <Fragment>
        <p>By signing up for our newsletter you will be awarded 50ASC.</p>
        <form onSubmit={this.handleSigningUp}>
          <div className="c-form-row">
            <label>Address</label>
            <input type="text" placeholder="Address" name="address" value={this.state.address}
                   onChange={this.handleAddressChange}/>
          </div>
          <div className="c-form-row">
            <label>Email</label>
            <input type="email" placeholder="Email" name="email" value={this.state.email}
                   onChange={this.handleEmailChange}/>
          </div>
          <div className="c-form-row">
            <label className="c-checkbox-container">
              <input type="checkbox" checked={this.state.acceptedTOS} onChange={this.handleAcceptTOSClick}/>
              <span className="checkmark"></span>
              By submitting this form I accept that my email will be added to AsyncCoin newsletter for promotional
              purposes.
            </label>
          </div>
          <div className="c-form-row">
            <input type="submit" value="Sign up for newsletter"/>
          </div>
        </form>
      </Fragment>
    );
  }

  render () {
    return (
      <div className={this.renderComponentClasses()}>
        <h2>Newsletter</h2>
        {this.renderForm()}
      </div>
    );
  }

  handleAddressChange = (event) => {
    this.setState({address: event.target.value});
  };

  handleEmailChange = (event) => {
    this.setState({email: event.target.value});
  };

  isFormValid () {
    if (this.state.address === '') {
      window.notifications.showError('Address field is empty.');
      return false;
    }

    if (this.state.email === '') {
      window.notifications.showError('Email field is empty.');
      return false;
    }

    if (!this.state.acceptedTOS) {
      window.notifications.showError('You have to accept Terms of service.');
      return false;
    }

    return true;
  }

  handleSigningUp = (event) => {
    event.preventDefault();

    if (!this.isFormValid()) {
      return;
    }

    this.setState({loading: true});

    window.requestHelper.postAPICall('/email-address/get-initial-bonus', {
      email: this.state.email,
      address: this.state.address
    })
      .then((res) => {
        const data = res.data;

        this.setState({loading: false});
        if (data.success) {
          this.setState({
            address: Storage.getState().account.currentAccount,
            email: '',
            acceptedTOS: false
          });

          window.notifications.showSuccess(
            'You have successfully signed up for Newsletter, you should get 50ASC as soon as transaction is mined on Ethereum Blockchain. If you don\'t receive you coins inside of 5 minutes, please contact us at coin@asynclabs.co');
          return;
        }

        window.notifications.showError(data.msg);
      })
      .catch((err) => {
        console.log(err);
        this.setState({loading: false});
        window.notifications.showError('There was error with this action.');
      });
  };

  handleAcceptTOSClick = (event) => {
    this.setState({acceptedTOS: event.target.checked});
  };
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Newsletter.js